import React from "react";
const PageFilters = ({
  specialitiesList,
  onSelect,
  allCount,
  activeSpecialty,
  isCollapsed = false,
  showLabels = false,
}) => {
  return (
    <nav className="notes-nav-tabs">
      <div
        className="nav nav-tabs d-flex-lg-1 pe-2  p-l-2p"
        id="nav-tab-account-checks"
        role="tablist"
      >
        <a
          className={`nav-item nav-link show rlmargin-z note-categories-spaces notes-all-left-tab ${activeSpecialty === "all" ? "active" : ""}`}
          id="custom-nav-all-tab"
          href="#custom-nav-all"
          role="tab"
          aria-controls="custom-nav-all"
          aria-selected="true"
          onClick={() => onSelect("all", "All")}
        >
          All <span className="m-l-5">{allCount}</span>
        </a>
        {!isCollapsed &&
          specialitiesList
            .filter((specialitie) => specialitie.doc_count !== 0)
            .map((tab, index) => (
              <a
                key={index}
                className={`nav-item rlmargin-z nav-link note-categories-spaces ${activeSpecialty === tab?.id ? "active" : ""}`}
                role="tab"
                aria-selected="true"
                onClick={() => onSelect(tab?.id, tab?.name)}
                style={{
                  transition: "none",
                }}
              >
                <span
                  className="ic-avatar ic-15 m-r-5"
                  style={{
                    width: "15px",
                    height: "15px",
                  }}
                >
                  <img alt={tab?.name} src={tab.page_icon} />
                </span>
                {showLabels && <span className="page-filter-label">{tab?.name}</span>}
                {tab?.doc_count || tab?.photo_count || ""}
              </a>
            ))}
      </div>
    </nav>
  );
};

export default React.memo(PageFilters);
